import Dashboard from "./Components/Dashboard";
import "./App.css";
function App() {
  return (
    <div className="container">
      <Dashboard />;
    </div>
  );
}

export default App;
